module.exports = __webpack_public_path__ + "static/media/HealthHustler.f417355c.svg";